import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export enum SubscriptionEvent {
  PROJECT_CREATED = 'PROJECT_CREATED',
  PROJECT_UPDATED = 'PROJECT_UPDATED',
  CONTACT_CREATED = 'CONTACT_CREATED',
  CONTACT_UPDATED = 'CONTACT_UPDATED',
  CONTACT_DELETED = 'CONTACT_DELETED',
  EMAIL_SENT = 'EMAIL_SENT',
  SMS_SENT = 'SMS_SENT',
  PROJECT_NOTE_CREATED = 'PROJECT_NOTE_CREATED',
  PROJECT_NOTE_UPDATED = 'PROJECT_NOTE_UPDATED',
  CONTACT_NOTE_CREATED = 'CONTACT_NOTE_CREATED',
  CONTACT_NOTE_UPDATED = 'CONTACT_NOTE_UPDATED',
}

export interface CreateWebhookSubscriptionRequest {
  webhookUrl: string;
  eventType: SubscriptionEvent;
}

export interface WebhookSubscription {
  id: number;
  webhookUrl: string;
  eventType: SubscriptionEvent;
  isEnabled: boolean;
  totalNumberOfSuccessRequests: number;
  totalNumberOfErrorRequests: number;
  currentErrorRequests: number;
}

export const SUBSCRIPTIONS_UPDATED = 'SUBSCRIPTIONS_UPDATED';

export function useWebhookSubscriptionsService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const createSubscription = async (request: CreateWebhookSubscriptionRequest): Promise<WebhookSubscription> => {
    const response = await nekstApi.post('/integrations/subscriptions', request) as WebhookSubscription;
    eventsPublisher.publish(SUBSCRIPTIONS_UPDATED, {});
    return response;
  };

  const getSubscriptions = async (): Promise<WebhookSubscription[]> => {
    return await nekstApi.get('/integrations/subscriptions') as WebhookSubscription[];
  };

  const cancelSubscription = async (subscriptionId: number): Promise<void> => {
    await nekstApi.delete(`/integrations/subscriptions/${subscriptionId}`);
    eventsPublisher.publish(SUBSCRIPTIONS_UPDATED, {});
  };

  return {
    createSubscription,
    getSubscriptions,
    cancelSubscription,
  };
} 